import type API from "@/Api/API";
import type {
	BetaRegistrationDto,
	BetaRegistrationLink,
	BetaRegistrationLinkDto,
} from "@/types/betaRegistration";

export default class BetaRegistration {
	api: API;

	constructor(api: API) {
		this.api = api;
	}

	async getLinks(): Promise<BetaRegistrationLink[]> {
		return this.api
			.processRequest("GET", "/admin/beta-registration-links")
			.then((res) => res.data);
	}

	async getLink(id: number): Promise<BetaRegistrationLink> {
		return this.api
			.processRequest("GET", `/admin/beta-registration-links/${id}`)
			.then((res) => res.data);
	}

	async createLink(
		dto: BetaRegistrationLinkDto
	): Promise<BetaRegistrationLink> {
		return this.api
			.processRequest("POST", "/admin/beta-registration-links", {
				data: dto,
			})
			.then((res) => res.data);
	}

	async updateLink(
		id: number,
		dto: BetaRegistrationLinkDto
	): Promise<BetaRegistrationLink> {
		return this.api
			.processRequest("PUT", `/admin/beta-registration-links/${id}`, {
				data: dto,
			})
			.then((res) => res.data);
	}

	async getPublicForm(token: string): Promise<{ token: string }> {
		return this.api
			.processRequest("GET", `/beta-registration/${token}`, {
				skipAuth: true,
			})
			.then((res) => res.data);
	}

	async recordVisit(token: string, visitorId: string): Promise<void> {
		await this.api.processRequest(
			"POST",
			`/beta-registration/${token}/visits`,
			{ data: { visitorId }, skipAuth: true }
		);
	}

	async register(token: string, dto: BetaRegistrationDto): Promise<void> {
		await this.api.processRequest(
			"POST",
			`/beta-registration/${token}/registrations`,
			{ data: dto, skipAuth: true }
		);
	}

	async exportCsv(id: number): Promise<Blob> {
		return this.api
			.processRequest(
				"GET",
				`/admin/beta-registration-links/${id}/export`,
				null,
				null,
				"blob"
			)
			.then((res) => res.data);
	}
}
